import { DefaultOptions, QueryClient } from "@tanstack/react-query";

/**
 * What every query in the panel runs on. Exported apart from the client
 * because a test that asks what the cache serves on mount is only answering
 * for the real screen if it asks under the real freshness window: `staleTime`
 * is the difference between a wrong row flashing and a wrong row sitting there
 * for half a minute. Tests build their own client from these and override only
 * what a test rig must (`retry`), rather than starting from library defaults
 * the app never uses.
 */
export const queryDefaults: DefaultOptions = {
  queries: {
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: 1,
  },
  mutations: { retry: 0 },
};

export const queryClient = new QueryClient({ defaultOptions: queryDefaults });
